{
	"main": {
		"title": "Programma giornaliero",
		"subtitle1": "PROGRAMMA DI VOLO:",
		"subtitle2": "AVVISO",
		"subSubtitle2": "PER ALTRE ATTIVITÀ IN CIELO:",
		"nazaj": "Indietro"
	},
	"nav": {
		"vnos": "Inserimento",
		"zapisi": "Record"
	},
	"labels": {
		"planirano": "Programmato (Rotta, Circuito, Addestramento,..)",
		"sredstvoTitle": "Mezzo:",
		"sredstvo": "",
		"izvrsilec": "Esecutore (Nome, Cognome)",
		"vrstaLetala": "Seleziona tipo di aereo: ",
		"casAktivnosti": "Ora attività:",
		"opisAktivnosti": "Descrizione attività (es. Paracadutisti nella zona dell'aeroporto..)",
		"naloga": "eleziona compito: "
	},
	"buttons": {
		"dodajSredstvo": "Aggiungi mezzo",
		"vnesiRazpored": "Inserisci nel programma",
		"vnesiOpozorilo": "Inserisci avviso",
		"brisiIzbiro": "Cancella selezione"
	},
	"obvestila": {
	  	"brisiSredstvo": "Vuoi davvero eliminare il bene?",
	  	"vnosUspesen": "inserimento riuscito",
	  	"vnosNeuspesen": "Errore durante l'inserimento dei dati.",
		"napakaInputa": "Non avete compilato tutti i campi! Compilate tutti i campi!"
	}

}